const mix = window.mixpanel;
export default class TrackingService {
	track(event) {
		mix.track(event);
	}
}



// WEBPACK FOOTER //
// ./src/services/TrackingService.js